/* global require */
import * as React from "react";
import fetch from "node-fetch";
import { Button, Input, makeStyles } from "@fluentui/react-components";
import { Home32Filled } from "@fluentui/react-icons";
import ErrorBox from "./ErrorBox";

const config = require("config");

interface LoginProps {
  close: () => void;
  login: (accessToken: string, sessionId: string) => void;
}

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "0 1rem",
    margin: "auto",
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "1rem",
  },
  homeButton: { padding: "0.5rem 1rem", minWidth: "unset" },
  textInput: {
    marginBottom: "0.25rem",
  },
  submitButton: {
    marginTop: "0.5rem",
  },
});

const Login: React.FC<LoginProps> = (_props: LoginProps) => {
  const styles = useStyles();

  const [disabled, setDisabled] = React.useState<boolean>(false);
  const [email, setEmail] = React.useState<string>("");
  const [password, setPassword] = React.useState<string>("");
  const [errorMsg, setErrorMsg] = React.useState<string | null>(null);

  async function login(e: React.FormEvent) {
    e.preventDefault();
    e.stopPropagation();

    setDisabled(true);
    await fetch(`${config.apiUrl}/log-in`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: email, password: password }),
    })
      .then(async (res) => {
        const json = await res.json();
        if (res.status === 200 && json.success) {
          return json.data;
        } else {
          throw new Error(json.message);
        }
      })
      .then((data) => {
        setErrorMsg(null);
        _props.login(data.accessToken, data.sessionId);
      })
      .catch((err) => {
        setErrorMsg(err.message);
      })
      .finally(() => {
        setDisabled(false);
      });
  }

  return (
    <form className={styles.root} onSubmit={login}>
      <div className={styles.header}>
        <h1>Login</h1>
        <Button className={styles.homeButton} type="button" onClick={_props.close}>
          <Home32Filled />
        </Button>
      </div>
      <label>Email</label>
      <Input
        className={styles.textInput}
        type="email"
        placeholder="Email"
        autoComplete="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <label>Password</label>
      <Input
        className={styles.textInput}
        type="password"
        placeholder="Password"
        autoComplete="current-password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />
      <ErrorBox show={errorMsg !== null}>
        <span>Error: {errorMsg}</span>
      </ErrorBox>
      <Button className={styles.submitButton} type="submit" disabled={disabled}>
        Login
      </Button>
    </form>
  );
};

export default Login;
